/* eslint-disable import/prefer-default-export */
import type { State } from '../configureStore'
import { Suite as ActionTypes } from '../actionTypes'
import * as ReduxHelpers from '@src/utils/reduxHelpers'
import { toastInfo } from '@src/utils/toast'
import {
  GroupRuleInfo,
  IntentMgr
} from '@src/endpoints/services/intentMgr.service'
import * as CustomEndpoints from '@src/endpoints/custom.endpoints'
import { defaultHandleStatus } from '@src/endpoints/helpers'

// Action Creators
export type ActionTypes =
  | getSuitesAction
  | getReportAction
  | reportGeneratedAction

const getSuites = (
  suites: GroupRuleInfo[],
  total = 0,
  failing = 0,
  passing = 0
) =>
  ReduxHelpers.Actions.createPayloadAction(ActionTypes.GET_SUITES, {
    suites,
    total,
    passing,
    failing
  })
type getSuitesAction = ReturnType<typeof getSuites>

const getReport = (pendingReport: string | number) =>
  ReduxHelpers.Actions.createPayloadAction(ActionTypes.GET_REPORT, {
    pendingReport
  })
type getReportAction = ReturnType<typeof getReport>

const reportGenerated = () =>
  ReduxHelpers.Actions.createPayloadAction(ActionTypes.REPORT_GENERATED, {
    pendingReport: null
  })
type reportGeneratedAction = ReturnType<typeof reportGenerated>

export function onGetSuites() {
  return (dispatch: any, getStore: () => State) => {
    IntentMgr.GetSuites({ params: {} })
      .then(res => defaultHandleStatus(res, null, true))
      .then(response => {
        const { suites, total_tests, failing_tests, passing_tests } = response
        dispatch(getSuites(suites, total_tests, failing_tests, passing_tests))
      })
      .catch(ex => ex)
  }
}

export function onGetReport(suiteId: string | number) {
  return (dispatch: any, getStore: () => State) => {
    const params: CustomEndpoints.GetReportReq = {
      suite_id: suiteId
    }
    dispatch(getReport(suiteId))
    toastInfo('Report generating started...')
    CustomEndpoints.getReport(params)
      .then(res => defaultHandleStatus(res, null, true))
      .then(res => {
        dispatch(reportGenerated())
        const a = window.document.createElement('a')
        a.href = window.URL.createObjectURL(res.file)
        a.setAttribute('download', `report ${new Date()}.xlsx`)
        a.click()
      })
      .catch(ex => ex)
  }
}
